import { render } from "./NextStepsGroup.vue?vue&type=template&id=6d1ca2fb&scoped=true"
import script from "./NextStepsGroup.vue?vue&type=script&lang=js"
export * from "./NextStepsGroup.vue?vue&type=script&lang=js"

import "./NextStepsGroup.vue?vue&type=style&index=0&id=6d1ca2fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1ca2fb"]])

export default __exports__